import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {CommonUtil} from '../../../utils/common.util';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css']
})
export class DropDownComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();

  @Input() dropDownObj;
  @Input() disable;
  @Input() dropDownModel;
  @Input() parentClass: string;
  @Output() menuSelect: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onChangeObj(item) {
    this.menuSelect.emit(item);
  }

}
